import classNames from 'classnames'
import './index.scss'

const SubscriptionTabs = ({tabs, activeTab, onChangeTabs, isDarkMode}) => {
    return <div className={classNames('tabs-container', {
        dark: isDarkMode
    })}>
        {tabs.map(({key, label}) => (
            <span key={key} className={classNames('tab', {'active': activeTab === key})} onClick={() => onChangeTabs(key)}>{label}</span>
        ))}
    </div>
}

export default SubscriptionTabs
